export default "__VITE_ASSET__DTPWVerS__"